module.exports = __webpack_public_path__ + "img/open_space.90e54fba.png";